import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export const BagSearchInput = ({ value, onChange }: Props) => (
  <div className="relative">
    <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
    <Input
      className="pl-9"
      placeholder="Buscar por nome, WhatsApp ou Instagram..."
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);
